<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Salariés')
</script>

<template>
  <q-page flex> Salariés </q-page>
</template>
